import {
    Dialog,
    Grid,
    TextField,
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { withStyles } from '@mui/styles';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { fetchMissionExperts } from '../../../Api/suiviMission/experts';
import { createTask } from '../../../Api/suiviMission/tasks';
import { useGlobalContext } from '../../../Contexts/suiviMission/GlobalContext';
import { taskModalPriorityEnum, taskModalProgressEnum } from '../../../data/Interfaces';
import { buttonStyles } from '../../docsAdministrative/JsObjectStyles';
import { SelectComponent } from '../../shared/ReusableSmallComponents';

// import moment from "moment";
// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 400,
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
// };

const styles = {
    dialogPaper: {
        minHeight: '45vh',
        maxHeight: '45vh',
    },
};

function AddTaskModal({ handleClose, open, classes }) {
    AddTaskModal.propTypes = {
        classes: PropTypes.any,
        open: PropTypes.func,
        handleClose: PropTypes.func,
    };
    const [missionExperts, setmissionExperts] = useState([]);
    const { mission } = useGlobalContext();
    const { i18n } = useTranslation();
    const defaultValues = {
        title: '',
        status: 'to do',
        priority: 'medium',
        expertId: [],
        missionId: mission._id,
        // dateDebut: new Date().now ,
        // dateFin: new Date().now ,
    };
    useEffect(() => {
        if (!mission._id) return;
        fetchMissionExperts(setmissionExperts, mission._id);
    }, [mission]);
    const [formValues, setFormValues] = useState(defaultValues);
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormValues({
            ...formValues,
            [name]: value,
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        //api call
        const tk = createTask(formValues);
        console.log(tk);
        handleClose();
    };

    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth="md"
                maxHeight="md"
                open={open}
                onClose={handleClose}
                scroll="body"
                classes={{ paper: classes.dialogPaper }}
            >
                <form onSubmit={(e) => handleSubmit(e)}>
                    <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Grid
                            item
                            xs={12}
                        >
                            <Box
                                sx={{ color: '#5778FF' }}
                                className="fw-bold text-center mt-2"
                            >
                                {mission.title} - {i18n.t('Nouvelle Tâche')}
                            </Box>
                        </Grid>
                        <Grid
                            item
                            xs={1}
                        ></Grid>
                        <Grid
                            item
                            xs={1}
                        >
						    {i18n.t('Titre')} :
                        </Grid>
                        <Grid
                            item
                            xs={10}
                        >
                            <TextField
                                id="outlined-basic"
                                label="Outlined"
                                variant="outlined"
                                fullWidth
                                name="title"
                                value={formValues.title}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={1}
                        ></Grid>
                        <Grid
                            item
                            xs={3}
                        >
                            <SelectComponent
                                label={i18n.t('Statut')}
                                val={formValues.status}
                                setVal={(e)=>handleChange(e)}
                                listVal={taskModalProgressEnum}
                            />
                            {/*<FormControl fullWidth>
                                <InputLabel id="status">Statut</InputLabel>
                                <Select
                                    labelId="status"
                                    id="status-select"
                                    value={formValues.status}
                                    label="Statut"
                                    name="status"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="to do">To do</MenuItem>
                                    <MenuItem value="in progress">In progress</MenuItem>
                                    <MenuItem value="done">Done</MenuItem>
                                </Select>
                            </FormControl>*/}
                        </Grid>
                        <Grid
                            item
                            xs={3}
                        >
                            <SelectComponent
                                label={i18n.t('Priorité')}
                                val={formValues.priority}
                                setVal={(e)=>handleChange(e)}
                                listVal={taskModalPriorityEnum}
                            />
                            {/*<FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Priorité</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={formValues.priority}
                                    label="Priorité"
                                    name="priority"
                                    onChange={handleChange}
                                >
                                    <MenuItem value="high">high</MenuItem>
                                    <MenuItem value="low">low</MenuItem>
                                    <MenuItem value="medium">medium</MenuItem>
                                </Select>
                            </FormControl>*/}
                        </Grid>
                        <Grid
                            item
                            xs={3}
                        >
                            <SelectComponent
                                label={i18n.t('Responsable')}
                                val={formValues?.expertId}
                                setVal={(e)=>handleChange(e)}
                                listVal={missionExperts.map((expert)=> { return {
                                    value: expert?._id,
                                    label: expert?.persoData.nom
                                }; })}
                            />
                            {/*<FormControl fullWidth>
                                <InputLabel id="responsable">Responsable</InputLabel>
                                <Select
                                    labelId="responsable"
                                    id="responsable-select"
                                    value={formValues.expertId}
                                    label="Responsable"
                                    defaultValue=""
                                    name="expertId"
                                    onChange={handleChange}
                                >
                                    {missionExperts.map((expert, index) => (
                                        <MenuItem
                                            key={index}
                                            value={expert._id}
                                        >
                                            {expert.persoData.nom}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>*/}

                            {/* <ButtonBase
                  sx={{ width: "100%" }}
                  onClick={() => {
                    responsableOptions(missionExperts);
                  }}
                >
                  <Autocomplete
                    disablePortal
                    id="combo-box-priority"
                    sx={{ width: "100%" }}
                    options={respOptions}
                    //TODO : make respo name dynamic
                    name="responsable"
                    onChange={(event, value) => {
                      console.log(event.target.name);
                      setFormValues({
                        ...formValues,
                        "responsable": [value.label],
                      });
                    }}

                    renderInput={(params) => (
                      <TextField {...params} label="Responsable" />
                    )}
                  />
                </ButtonBase> */}
                            <Grid
                                item
                                xs={2}
                            ></Grid>
                        </Grid>
                        <Grid
                            item
                            xs={2}
                        ></Grid>
                        <Grid
                            item
                            xs={10}
                        >
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <Stack
                                    direction="row"
                                    spacing={3}
                                >
                                    <DesktopDatePicker
                                        label="Date de début"
                                        inputFormat="DD/MM/yyyy"
                                        value={formValues.dateDebut}
                                        id="dateDebut"
                                        onChange={(newValue) => {
                                            setFormValues({
                                                ...formValues,
                                                dateDebut: newValue,
                                            });
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                    <DesktopDatePicker
                                        label={i18n.t('Date de fin')}
                                        inputFormat="DD/MM/yyyy"
                                        value={formValues.dateFin}
                                        onChange={(newValue) => {
                                            setFormValues({
                                                ...formValues,
                                                dateFin: newValue,
                                            });
                                        }}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </Stack>
                            </LocalizationProvider>
                        </Grid>
                        <Grid
                            item
                            xs={9}
                        ></Grid>
                        <Grid
                            item
                            xs={1}
                        >
                            <Button
                                variant="outlined"
                                color="success"
                                style={{...buttonStyles()}}
                                type="submit"
                            >
							    {i18n.t('Créer')}
                            </Button>
                        </Grid>
                        <Grid
                            item
                            xs={1}
                        >
                            <Button
                                variant="outlined"
                                color="error"
                                style={{...buttonStyles()}}
                                onClick={handleClose}
                            >
                                {i18n.t('Annuler')}
                            </Button>
                        </Grid>
                        <Grid
                            item
                            xs={1}
                        ></Grid>
                    </Grid>
                    {/* <input  value={formValues.missionId} name="missionId" onChange={handleChange}></input> */}
                    {/* <input
                  id="outlined"
                  label="Outlined"
                  variant="outlined"
                  type="hidden"
                  fullWidth
                  name="missionId"
                  value={formValues.missionId}

                /> */}
                </form>
            </Dialog>
        </div>
    );
}

export default withStyles(styles)(AddTaskModal);
